var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGalicia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 600,
    height: 400,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M.04 96.048h600v399.969H.04z",
    style: {
      fontSize: 12,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "evenodd",
      strokeWidth: "1pt"
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.04 437.797 86.07 96.048H.04v56.935l515.896 343.034h84.104v-58.22",
    style: {
      fontSize: 12,
      fill: "#09c"
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.648 401.235c-60.134 0-58.18-56.575-58.18-56.575v-86.833h116.36v86.833s2.036 56.575-58.18 56.575",
    style: {
      fontSize: 12,
      fill: "#005bbf",
      fillOpacity: 1
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.648 401.235c-60.134 0-58.18-56.575-58.18-56.575v-86.833h116.36v86.833s2.036 56.575-58.18 56.575z",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.0063988
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.137 203.179s-12.407-6.036-24.143 2.85c0 0-21.118-3.047-22.672 17.18-.063.82-.19 2.328.187 2.768.377.44.754 1.258.754 1.82 0 .567.378.882.505 1.132.125.252.44.629.502 1.698.062 1.068-.125 1.57.881 2.64 1.004 1.068 1.067 4.15 1.067 5.029 0 .879.63 3.33 1.069 3.835.44.502 1.194 1.758 1.194 2.827s.44 4.023.25 4.775c-.188.754 1.13 1.698 2.327 2.075 1.194.377 16.03 5.217 37.656 4.84 21.628-.377 29.415-1.528 38.35-4.777 1.381-.502 1.634-1.634 1.509-2.263-.128-.627 0-2.637.377-3.141.377-.502 2.892-4.525 2.387-5.28-.502-.754-.502-2.39 0-3.016.505-.63 2.078-3.653 2.388-4.905.312-1.254.353-2.73.93-3.168.579-.437.773-1.854.884-2.15.112-.297.533-1.22 1.119-1.64 0 0 1.09-5.11.418-7.623-.668-2.515-4.441-13.328-19.78-11.063 0 0-11.4-8.634-28.164-4.443",
    style: {
      fontSize: 12,
      fill: "#d81126",
      fillOpacity: 1
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.137 203.179s-12.407-6.036-24.143 2.85c0 0-21.118-3.047-22.672 17.18-.063.82-.19 2.328.187 2.768.377.44.754 1.258.754 1.82 0 .567.378.882.505 1.132.125.252.44.629.502 1.698.062 1.068-.125 1.57.881 2.64 1.004 1.068 1.067 4.15 1.067 5.029 0 .879.63 3.33 1.069 3.835.44.502 1.194 1.758 1.194 2.827s.44 4.023.25 4.775c-.188.754 1.13 1.698 2.327 2.075 1.194.377 16.03 5.217 37.656 4.84 21.628-.377 29.415-1.528 38.35-4.777 1.381-.502 1.634-1.634 1.509-2.263-.128-.627 0-2.637.377-3.141.377-.502 2.892-4.525 2.387-5.28-.502-.754-.502-2.39 0-3.016.505-.63 2.078-3.653 2.388-4.905.312-1.254.353-2.73.93-3.168.579-.437.773-1.854.884-2.15.112-.297.533-1.22 1.119-1.64 0 0 1.09-5.11.418-7.623-.668-2.515-4.441-13.328-19.78-11.063 0 0-11.4-8.634-28.164-4.443h.005z",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.50839722
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.643 240.834c-47.108-14.92-83.414-.74-83.414-.74s.336 1.646.754 2.148c.42.502 1.007 1.676 1.007 2.558 0 .879.084 2.137.084 2.807 0 .668-.514 3.675 2.174 3.64 0 0 32.741-12.843 75.377.66 0 0 1.167-1.048 1.21-2.556.041-1.508.291-3.1.88-3.939.586-.838 1.926-3.456 1.926-4.578",
    style: {
      fontSize: 12,
      fill: "#bcac0b",
      fillOpacity: 1
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.968 319.347h-20.453s-2.013 18.27 13.746 23.805v1.676h3.354v2.179s-5.784 5.195-.757 11.146v1.845h.84v2.933h.92v4.774s-.754 17.058-17.476 25.229v1.006h44.65v-1.006c-16.72-8.171-17.476-25.229-17.476-25.229v-4.774h.92v-2.933h.838v-1.845c5.03-5.951-.754-11.147-.754-11.147v-2.178h3.353v-1.676c15.76-5.534 13.746-23.805 13.746-23.805h-25.454",
    style: {
      fontSize: 12,
      fill: "#c8b100",
      fillOpacity: 0.94117647
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.968 319.347h-20.453s-2.013 18.27 13.746 23.805v1.676h3.354v2.179s-5.784 5.195-.757 11.146v1.845h.84v2.933h.92v4.774s-.754 17.058-17.476 25.229v1.006h44.65v-1.006c-16.72-8.171-17.476-25.229-17.476-25.229v-4.774h.92v-2.933h.838v-1.845c5.03-5.951-.754-11.147-.754-11.147v-2.178h3.353v-1.676c15.76-5.534 13.746-23.805 13.746-23.805h-25.454.003z",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.0063988
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.589 342.9h19.742m-19.07 1.508h18.4m-15.046 2.514h11.568m-12.325 11.44h13.204m-12.323 1.405h11.528m-11.528 2.851h11.484M283.7 385.772h25.524m-32.732 5.908h39.984m-41.493.88h43.042",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.25220016
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.639 318.269c7.201 0 13.04-5.839 13.04-13.04 0-7.2-5.839-13.04-13.04-13.04-7.201 0-13.04 5.84-13.04 13.04 0 7.201 5.839 13.04 13.04 13.04",
    style: {
      fontSize: 12,
      fill: "#ccc",
      fillOpacity: 1
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.639 318.269c7.201 0 13.04-5.839 13.04-13.04 0-7.2-5.839-13.04-13.04-13.04-7.201 0-13.04 5.84-13.04 13.04 0 7.201 5.839 13.04 13.04 13.04z",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.0063988
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.294 279.955h-8.13v-8.132h-7.209v8.132h-8.13v7.206h8.13v8.13h7.209v-8.13h8.13v-7.206",
    style: {
      fontSize: 12,
      fill: "#ccc",
      fillOpacity: 1
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.294 279.955h-8.13v-8.132h-7.209v8.132h-8.13v7.206h8.13v8.13h7.209v-8.13h8.13v-7.206",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.0063988
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.8 279.955h-8.132v-8.132h-7.21v8.132h-8.129v7.206h8.128v8.13h7.211v-8.13h8.131v-7.206",
    style: {
      fontSize: 12,
      fill: "#ccc",
      fillOpacity: 1
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.8 279.955h-8.132v-8.132h-7.21v8.132h-8.129v7.206h8.128v8.13h7.211v-8.13h8.131v-7.206",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.0063988
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.976 269.738h-8.13v-8.13h-7.209v8.13h-8.13v7.208h8.13v8.13h7.208v-8.13h8.131v-7.208",
    style: {
      fontSize: 12,
      fill: "#ccc",
      fillOpacity: 1
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.976 269.738h-8.13v-8.13h-7.209v8.13h-8.13v7.208h8.13v8.13h7.208v-8.13h8.131v-7.208",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.0063988
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.294 315.156h-8.13v-8.13h-7.209v8.13h-8.13v7.208h8.13v8.13h7.209v-8.13h8.13v-7.208",
    style: {
      fontSize: 12,
      fill: "#ccc",
      fillOpacity: 1
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.294 315.156h-8.13v-8.13h-7.209v8.13h-8.13v7.208h8.13v8.13h7.209v-8.13h8.13v-7.208",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.0063988
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.8 315.156h-8.132v-8.13h-7.21v8.13h-8.129v7.208h8.128v8.13h7.211v-8.13h8.131v-7.208",
    style: {
      fontSize: 12,
      fill: "#ccc",
      fillOpacity: 1
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.8 315.156h-8.132v-8.13h-7.21v8.13h-8.129v7.208h8.128v8.13h7.211v-8.13h8.131v-7.208",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.0063988
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.294 350.705h-8.13v-8.132h-7.209v8.132h-8.13v7.208h8.13v8.128h7.209v-8.128h8.13v-7.208",
    style: {
      fontSize: 12,
      fill: "#ccc",
      fillOpacity: 1
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.294 350.705h-8.13v-8.132h-7.209v8.132h-8.13v7.208h8.13v8.128h7.209v-8.128h8.13v-7.208",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.0063988
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.8 350.705h-8.132v-8.132h-7.21v8.132h-8.129v7.208h8.128v8.128h7.211v-8.128h8.131v-7.208",
    style: {
      fontSize: 12,
      fill: "#ccc",
      fillOpacity: 1
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.8 350.705h-8.132v-8.132h-7.21v8.132h-8.129v7.208h8.128v8.128h7.211v-8.128h8.131v-7.208",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.0063988
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.533 185.773a7.824 7.824 0 0 0 7.826-7.823 7.824 7.824 0 0 0-7.826-7.823 7.822 7.822 0 0 0-7.823 7.823 7.822 7.822 0 0 0 7.823 7.823",
    style: {
      fontSize: 12,
      fill: "#005bbf",
      fillOpacity: 1
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.533 185.773a7.824 7.824 0 0 0 7.826-7.823 7.824 7.824 0 0 0-7.826-7.823 7.822 7.822 0 0 0-7.823 7.823 7.822 7.822 0 0 0 7.823 7.823z",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.0063988
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.828 176.567h-6.413v-10.371h2.45v-2.076h-2.45v-2.452h-2.076v2.452h-2.452v2.076h2.452v10.37h-6.098v1.384h6.098v.062h2.076v-.062h6.413v-1.383",
    style: {
      fontSize: 12,
      fill: "#fc0",
      fillOpacity: 1
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.828 176.567h-6.413v-10.371h2.45v-2.076h-2.45v-2.452h-2.076v2.452h-2.452v2.076h2.452v10.37h-6.098v1.384h6.098v.062h2.076v-.062h6.413v-1.383",
    style: {
      fontSize: 12,
      fill: "#bcac0b",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.50199842
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.206 195.133s5.784-.67 9.135.67c0 0-3.84 4.369-3.017 10.14.42 2.935 1.007 4.444 1.845 5.868.838 1.426 1.758 4.36 1.256 6.706h1.09s1.091-4.778-.754-7.46c-1.844-2.68-2.767-6.37-.922-10.225 1.842-3.855 4.525-5.363 4.525-5.363 3.101 1.256 9.642.082 11.484-1.259 1.843-1.342 2.765-3.184-.67-3.353-3.435-.168-9.303-.084-13.326 2.935 0 0-2.097-2.433-12.575-1.258-10.477 1.174-18.05 5.649-20.369 15.088-1.172 4.777 3.27 14.834 7.377 17.264 0 0-.125-1.633.293-2.807 0 0-7-7.838-4.902-15.13 2.094-7.291 10.477-12.069 19.53-11.816",
    style: {
      fontSize: 12,
      fill: "#fc0",
      fillOpacity: 1
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.206 195.133s5.784-.67 9.135.67c0 0-3.84 4.369-3.017 10.14.42 2.935 1.007 4.444 1.845 5.868.838 1.426 1.758 4.36 1.256 6.706h1.09s1.091-4.778-.754-7.46c-1.844-2.68-2.767-6.37-.922-10.225 1.842-3.855 4.525-5.363 4.525-5.363 3.101 1.256 9.642.082 11.484-1.259 1.843-1.342 2.765-3.184-.67-3.353-3.435-.168-9.303-.084-13.326 2.935 0 0-2.097-2.433-12.575-1.258-10.477 1.174-18.05 5.649-20.369 15.088-1.172 4.777 3.27 14.834 7.377 17.264 0 0-.125-1.633.293-2.807 0 0-7-7.838-4.902-15.13 2.094-7.291 10.477-12.069 19.53-11.816z",
    style: {
      fontSize: 12,
      fill: "#bcac0b",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.65331852
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.898 193.69c1.81-.147 3.262-.462 3.243-.71-.02-.242-1.504-.324-3.315-.177-1.811.146-3.262.463-3.243.708.02.245 1.504.325 3.315.178",
    style: {
      fontSize: 12,
      fill: "#fff"
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.302 195.426s-2.073 1.948 0 0c2.075-1.948 6.413-3.27 8.866-2.702 2.45.564-.442.879-1.259.941-.817.063-2.452.377-4.84 0",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.65331852
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.735 195.76s-5.782-.668-9.135.672c0 0 3.843 4.366 3.017 10.14-.418 2.935-1.004 4.444-1.842 5.868-.84 1.422-1.76 4.36-1.259 6.706h-1.09s-1.088-4.777.754-7.46c1.845-2.683 2.767-6.37.922-10.225-1.842-3.857-4.525-5.365-4.525-5.365-3.101 1.258-9.64.084-11.484-1.256-1.84-1.343-2.765-3.185.67-3.353 3.437-.168 9.305-.084 13.329 2.932 0 0 2.094-2.43 12.572-1.256 10.48 1.172 18.05 5.65 20.369 15.086 1.174 4.777-3.27 14.836-7.377 17.267 0 0 .128-1.634-.293-2.808 0 0 7-7.837 4.905-15.13-2.097-7.291-10.477-12.068-19.533-11.819",
    style: {
      fontSize: 12,
      fill: "#fc0",
      fillOpacity: 1
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.735 195.76s-5.782-.668-9.135.672c0 0 3.843 4.366 3.017 10.14-.418 2.935-1.004 4.444-1.842 5.868-.84 1.422-1.76 4.36-1.259 6.706h-1.09s-1.088-4.777.754-7.46c1.845-2.683 2.767-6.37.922-10.225-1.842-3.857-4.525-5.365-4.525-5.365-3.101 1.258-9.64.084-11.484-1.256-1.84-1.343-2.765-3.185.67-3.353 3.437-.168 9.305-.084 13.329 2.932 0 0 2.094-2.43 12.572-1.256 10.48 1.172 18.05 5.65 20.369 15.086 1.174 4.777-3.27 14.836-7.377 17.267 0 0 .128-1.634-.293-2.808 0 0 7-7.837 4.905-15.13-2.097-7.291-10.477-12.068-19.533-11.819z",
    style: {
      fontSize: 12,
      fill: "#bcac0b",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.65331852
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.043 194.318c-1.808-.146-3.261-.463-3.242-.708.021-.245 1.503-.324 3.315-.178 1.81.147 3.264.464 3.245.709-.022.245-1.506.324-3.318.177",
    style: {
      fontSize: 12,
      fill: "#fff"
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.64 196.055s2.075 1.948 0 0c-2.074-1.95-6.412-3.269-8.864-2.705-2.452.567.44.882 1.256.944.82.063 2.453.377 4.843 0",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.65331852
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.107 189.349v22.296c-.252 2.179 2.68 5.28 4.778 6.202 0 0 4.945-1.677 5.28-6.202V188.09h-1.677v20.368c-.082 2.097-1.425 5.868-3.27 6.456 0 0-3.603-.588-3.77-6.372v-19.86l-1.341.667",
    style: {
      fontSize: 12,
      fill: "#fc0",
      fillOpacity: 1
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.107 189.349v22.296c-.252 2.179 2.68 5.28 4.778 6.202 0 0 4.945-1.677 5.28-6.202V188.09h-1.677v20.368c-.082 2.097-1.425 5.868-3.27 6.456 0 0-3.603-.588-3.77-6.372v-19.86l-1.341.667",
    style: {
      fontSize: 12,
      fill: "#bcac0b",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.65331852
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.777 219.842a2.666 2.666 0 1 0 0-5.332 2.666 2.666 0 0 0 0 5.332",
    style: {
      fontSize: 12,
      fill: "#fff"
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.777 219.842a2.666 2.666 0 1 0 0-5.332 2.666 2.666 0 0 0 0 5.332z",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.0063988
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.11 213.713a2.667 2.667 0 1 0 .004-5.333 2.667 2.667 0 0 0-.004 5.333",
    style: {
      fontSize: 12,
      fill: "#fff"
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.11 213.713a2.667 2.667 0 1 0 .004-5.333 2.667 2.667 0 0 0-.004 5.333z",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.0063988
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.992 206.296a2.667 2.667 0 1 0-.001-5.333 2.667 2.667 0 0 0 0 5.333",
    style: {
      fontSize: 12,
      fill: "#fff"
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.992 206.296a2.667 2.667 0 1 0-.001-5.333 2.667 2.667 0 0 0 0 5.333z",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.0063988
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.14 200.136a2.667 2.667 0 1 0 .004-5.334 2.667 2.667 0 0 0-.004 5.334",
    style: {
      fontSize: 12,
      fill: "#fff"
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.14 200.136a2.667 2.667 0 1 0 .004-5.334 2.667 2.667 0 0 0-.004 5.334z",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.0063988
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.045 195.642a2.667 2.667 0 1 0-.001-5.334 2.667 2.667 0 0 0 0 5.334",
    style: {
      fontSize: 12,
      fill: "#fff"
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.045 195.642a2.667 2.667 0 1 0-.001-5.334 2.667 2.667 0 0 0 0 5.334z",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.0063988
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.362 193.127a2.667 2.667 0 1 0-.001-5.333 2.667 2.667 0 0 0 .001 5.333",
    style: {
      fontSize: 12,
      fill: "#fff"
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.362 193.127a2.667 2.667 0 1 0-.001-5.333 2.667 2.667 0 0 0 .001 5.333z",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.0063988
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.963 191.933a2.668 2.668 0 0 0 0-5.334 2.666 2.666 0 1 0 0 5.334",
    style: {
      fontSize: 12,
      fill: "#fff"
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.963 191.933a2.668 2.668 0 0 0 0-5.334 2.666 2.666 0 1 0 0 5.334z",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.0063988
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.251 191.556a2.668 2.668 0 1 0-.004-5.336 2.668 2.668 0 0 0 .004 5.336",
    style: {
      fontSize: 12,
      fill: "#fff"
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.251 191.556a2.668 2.668 0 1 0-.004-5.336 2.668 2.668 0 0 0 .004 5.336z",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.0063988
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.908 192.058a2.666 2.666 0 1 0 0-5.332 2.666 2.666 0 0 0 0 5.332",
    style: {
      fontSize: 12,
      fill: "#fff"
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.908 192.058a2.666 2.666 0 1 0 0-5.332 2.666 2.666 0 0 0 0 5.332z",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.0063988
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.037 190.046a2.668 2.668 0 0 0 2.669-2.666 2.666 2.666 0 1 0-2.669 2.666",
    style: {
      fontSize: 12,
      fill: "#fff"
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.037 190.046a2.668 2.668 0 0 0 2.669-2.666 2.666 2.666 0 1 0-2.669 2.666z",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.0063988
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.192 191.429a2.668 2.668 0 0 0 2.669-2.666 2.668 2.668 0 0 0-5.335 0 2.666 2.666 0 0 0 2.666 2.666",
    style: {
      fontSize: 12,
      fill: "#fff"
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.192 191.429a2.668 2.668 0 0 0 2.669-2.666 2.668 2.668 0 0 0-5.335 0 2.666 2.666 0 0 0 2.666 2.666z",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.0063988
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.192 211.167a2.668 2.668 0 0 0 2.669-2.666 2.668 2.668 0 0 0-5.335 0 2.666 2.666 0 0 0 2.666 2.666",
    style: {
      fontSize: 12,
      fill: "#fff"
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.192 211.167a2.668 2.668 0 0 0 2.669-2.666 2.668 2.668 0 0 0-5.335 0 2.666 2.666 0 0 0 2.666 2.666z",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.0063988
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.328 221.54a2.667 2.667 0 1 0-.002-5.333 2.667 2.667 0 0 0 .002 5.334",
    style: {
      fontSize: 12,
      fill: "#fff"
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.328 221.54a2.667 2.667 0 1 0-.002-5.333 2.667 2.667 0 0 0 .002 5.334z",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.0063988
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.709 214.907a2.667 2.667 0 1 0 .003-5.334 2.667 2.667 0 0 0-.003 5.334",
    style: {
      fontSize: 12,
      fill: "#fff"
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.709 214.907a2.667 2.667 0 1 0 .003-5.334 2.667 2.667 0 0 0-.003 5.334z",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.0063988
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.577 207.994a2.667 2.667 0 1 0 .003-5.334 2.667 2.667 0 0 0-.003 5.334",
    style: {
      fontSize: 12,
      fill: "#fff"
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.577 207.994a2.667 2.667 0 1 0 .003-5.334 2.667 2.667 0 0 0-.003 5.334z",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.0063988
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.685 201.457a2.668 2.668 0 1 0-2.666-2.668 2.668 2.668 0 0 0 2.666 2.668",
    style: {
      fontSize: 12,
      fill: "#fff"
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.685 201.457a2.668 2.668 0 1 0-2.666-2.668 2.668 2.668 0 0 0 2.666 2.668z",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.0063988
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.783 196.93a2.666 2.666 0 1 0-2.669-2.667 2.668 2.668 0 0 0 2.669 2.666",
    style: {
      fontSize: 12,
      fill: "#fff"
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.783 196.93a2.666 2.666 0 1 0-2.669-2.667 2.668 2.668 0 0 0 2.669 2.666z",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.0063988
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.874 194.037a2.666 2.666 0 0 0 0-5.332 2.667 2.667 0 1 0 0 5.332",
    style: {
      fontSize: 12,
      fill: "#fff"
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.874 194.037a2.666 2.666 0 0 0 0-5.332 2.667 2.667 0 1 0 0 5.332z",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.0063988
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.146 192.498a2.667 2.667 0 1 0 .004-5.334 2.667 2.667 0 0 0-.004 5.334",
    style: {
      fontSize: 12,
      fill: "#fff"
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.146 192.498a2.667 2.667 0 1 0 .004-5.334 2.667 2.667 0 0 0-.004 5.334z",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.0063988
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.985 191.996a2.667 2.667 0 1 0 .003-5.335 2.667 2.667 0 0 0-.003 5.335",
    style: {
      fontSize: 12,
      fill: "#fff"
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.985 191.996a2.667 2.667 0 1 0 .003-5.335 2.667 2.667 0 0 0-.003 5.335z",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.0063988
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.4 191.26a2.667 2.667 0 1 0 .004-5.333 2.667 2.667 0 0 0-.004 5.334",
    style: {
      fontSize: 12,
      fill: "#fff"
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.4 191.26a2.667 2.667 0 1 0 .004-5.333 2.667 2.667 0 0 0-.004 5.334z",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.0063988
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.006 213.086a2.668 2.668 0 0 0 0-5.334 2.666 2.666 0 0 0 0 5.334",
    style: {
      fontSize: 12,
      fill: "#fff"
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.006 213.086a2.668 2.668 0 0 0 0-5.334 2.666 2.666 0 0 0 0 5.334z",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.0063988
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.39 207.93a2.666 2.666 0 0 0 0-5.333 2.667 2.667 0 1 0 0 5.332",
    style: {
      fontSize: 12,
      fill: "#fff"
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.39 207.93a2.666 2.666 0 0 0 0-5.333 2.667 2.667 0 1 0 0 5.332z",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.0063988
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.976 190.865a2.667 2.667 0 1 0 .004-5.335 2.667 2.667 0 0 0-.004 5.335",
    style: {
      fontSize: 12,
      fill: "#fff"
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.976 190.865a2.667 2.667 0 1 0 .004-5.335 2.667 2.667 0 0 0-.004 5.335z",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.0063988
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.926 190.142a2.667 2.667 0 1 0 .003-5.335 2.667 2.667 0 0 0-.003 5.335",
    style: {
      fontSize: 12,
      fill: "#fff"
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.926 190.142a2.667 2.667 0 1 0 .003-5.335 2.667 2.667 0 0 0-.003 5.335z",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.0063988
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.784 190.014a2.666 2.666 0 1 0 0-5.332 2.666 2.666 0 0 0 0 5.332",
    style: {
      fontSize: 12,
      fill: "#fff"
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.784 190.014a2.666 2.666 0 1 0 0-5.332 2.666 2.666 0 0 0 0 5.332z",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.0063988
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.84 213.149a2.668 2.668 0 1 0 0-5.332 2.668 2.668 0 0 0 0 5.332",
    style: {
      fontSize: 12,
      fill: "#fff"
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.84 213.149a2.668 2.668 0 1 0 0-5.332 2.668 2.668 0 0 0 0 5.332z",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.0063988
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.055 206.767a2.668 2.668 0 0 0 2.669-2.666 2.668 2.668 0 0 0-5.335 0 2.666 2.666 0 0 0 2.666 2.666",
    style: {
      fontSize: 12,
      fill: "#fff"
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.055 206.767a2.668 2.668 0 0 0 2.669-2.666 2.668 2.668 0 0 0-5.335 0 2.666 2.666 0 0 0 2.666 2.666z",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.0063988
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.94 200.606a2.667 2.667 0 1 0 .004-5.333 2.667 2.667 0 0 0-.003 5.333",
    style: {
      fontSize: 12,
      fill: "#fff"
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.94 200.606a2.667 2.667 0 1 0 .004-5.333 2.667 2.667 0 0 0-.003 5.333z",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.0063988
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.665 190.612a2.667 2.667 0 1 0 .004-5.333 2.667 2.667 0 0 0-.004 5.333",
    style: {
      fontSize: 12,
      fill: "#fff"
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.665 190.612a2.667 2.667 0 1 0 .004-5.333 2.667 2.667 0 0 0-.004 5.333z",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.0063988
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.233 192.435a2.667 2.667 0 1 0 .004-5.333 2.667 2.667 0 0 0-.004 5.333",
    style: {
      fontSize: 12,
      fill: "#fff"
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.233 192.435a2.667 2.667 0 1 0 .004-5.333 2.667 2.667 0 0 0-.004 5.333z",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.0063988
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.991 196.019a2.668 2.668 0 1 0-.004-5.337 2.668 2.668 0 0 0 .004 5.337",
    style: {
      fontSize: 12,
      fill: "#fff"
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.991 196.019a2.668 2.668 0 1 0-.004-5.337 2.668 2.668 0 0 0 .004 5.337z",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.0063988
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.192 194.448a2.67 2.67 0 0 0 2.669-2.668 2.666 2.666 0 1 0-2.669 2.668",
    style: {
      fontSize: 12,
      fill: "#fff"
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.192 194.448a2.67 2.67 0 0 0 2.669-2.668 2.666 2.666 0 1 0-2.669 2.668z",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.0063988
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.192 199.475a2.668 2.668 0 0 0 2.669-2.666 2.668 2.668 0 0 0-5.335 0 2.666 2.666 0 0 0 2.666 2.666",
    style: {
      fontSize: 12,
      fill: "#fff"
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.192 199.475a2.668 2.668 0 0 0 2.669-2.666 2.668 2.668 0 0 0-5.335 0 2.666 2.666 0 0 0 2.666 2.666z",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.0063988
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.192 204.882a2.668 2.668 0 0 0 2.669-2.666 2.666 2.666 0 1 0-2.669 2.666",
    style: {
      fontSize: 12,
      fill: "#fff"
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.192 204.882a2.668 2.668 0 0 0 2.669-2.666 2.666 2.666 0 1 0-2.669 2.666z",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.0063988
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.435 190.173a2.668 2.668 0 1 0-.004-5.337 2.668 2.668 0 0 0 .004 5.337",
    style: {
      fontSize: 12,
      fill: "#fff"
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.435 190.173a2.668 2.668 0 1 0-.004-5.337 2.668 2.668 0 0 0 .004 5.337z",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.0063988
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.081 189.419a2.668 2.668 0 1 0-.004-5.337 2.668 2.668 0 0 0 .004 5.337",
    style: {
      fontSize: 12,
      fill: "#fff"
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.081 189.419a2.668 2.668 0 1 0-.004-5.337 2.668 2.668 0 0 0 .004 5.337z",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.0063988
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.198 190.08a2.668 2.668 0 0 0 0-5.335 2.666 2.666 0 0 0 0 5.334",
    style: {
      fontSize: 12,
      fill: "#fff"
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.198 190.08a2.668 2.668 0 0 0 0-5.335 2.666 2.666 0 0 0 0 5.334z",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.0063988
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.508 201.392a2.668 2.668 0 0 0 2.668-2.666 2.668 2.668 0 0 0-5.335 0 2.666 2.666 0 0 0 2.667 2.666",
    style: {
      fontSize: 12,
      fill: "#fff"
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.508 201.392a2.668 2.668 0 0 0 2.668-2.666 2.668 2.668 0 0 0-5.335 0 2.666 2.666 0 0 0 2.667 2.666z",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.0063988
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.346 192.467a2.667 2.667 0 1 0 .004-5.334 2.667 2.667 0 0 0-.004 5.334",
    style: {
      fontSize: 12,
      fill: "#fff"
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.346 192.467a2.667 2.667 0 1 0 .004-5.334 2.667 2.667 0 0 0-.004 5.334z",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.0063988
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.12 196.113a2.667 2.667 0 1 0-.001-5.334 2.667 2.667 0 0 0 .001 5.334",
    style: {
      fontSize: 12,
      fill: "#fff"
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.12 196.113a2.667 2.667 0 1 0-.001-5.334 2.667 2.667 0 0 0 .001 5.334z",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.0063988
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m296.021 236.05-7.04 3.521 6.337 3.99 7.51-3.755-6.807-3.756",
    style: {
      fontSize: 12,
      fill: "#fff"
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m296.021 236.05-7.04 3.521 6.337 3.99 7.51-3.755-6.807-3.756",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.50199842
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m280.63 236.79-10.562 1.633s-.127 5.659.377 7.042l10.811-1.51s.505-5.28-.627-7.165",
    style: {
      fontSize: 12,
      fill: "#fff"
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m280.63 236.79-10.562 1.633s-.127 5.659.377 7.042l10.811-1.51s.505-5.28-.627-7.165z",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.50199842
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.455 238.8s-6.37.586-7.963 1.174l.084 3.855s4.192-.754 8.047-1.09l-.168-3.939",
    style: {
      fontSize: 12,
      fill: "#058e6e",
      fillOpacity: 0.94117647
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.455 238.8s-6.37.586-7.963 1.174l.084 3.855s4.192-.754 8.047-1.09l-.168-3.939",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.50199842
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m310.743 237.092 10.56 1.636s.127 5.656-.378 7.04l-10.811-1.509s-.504-5.281.63-7.167",
    style: {
      fontSize: 12,
      fill: "#fff"
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m310.743 237.092 10.56 1.636s.127 5.656-.378 7.04l-10.811-1.509s-.504-5.281.63-7.167z",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.50199842
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.916 239.105s6.37.586 7.962 1.172l-.084 3.855s-4.191-.754-8.047-1.088l.169-3.939",
    style: {
      fontSize: 12,
      fill: "#058e6e",
      fillOpacity: 0.94117647
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.916 239.105s6.37.586 7.962 1.172l-.084 3.855s-4.191-.754-8.047-1.088l.169-3.939",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.50199842
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.224 241.82s37.049-13.759 84.16 1.162m-82.651 6.756s35.835-13.402 80.03.595m-79.862-9.018 7.208 2.094-5.03 5.366",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.50199842
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256.069 247.768 4.107-3.437-4.693-.922s.639.725.507 1.39c-.13.666.038 2.383.079 2.97",
    style: {
      fontSize: 12,
      fill: "red"
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256.069 247.768 4.107-3.437-4.693-.922s.639.725.507 1.39c-.13.666.038 2.383.079 2.97zM337.586 242.698l-7.67 1.384 5.155 6.033",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.50199842
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m335.323 247.98-2.892-3.02 4.148-.376s-1.131.754-1.131 1.383c0 .63.127 1.508-.125 2.013",
    style: {
      fontSize: 12,
      fill: "red"
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m335.323 247.98-2.892-3.02 4.148-.376s-1.131.754-1.131 1.383c0 .63.127 1.508-.125 2.013zM265.29 241.845c.654 0 1.184-.425 1.184-.95 0-.522-.53-.947-1.184-.947-.655 0-1.186.425-1.186.946 0 .526.53.951 1.186.951zm20.607-2.348c.656 0 1.187-.426 1.187-.947 0-.526-.531-.949-1.187-.949-.653 0-1.184.423-1.184.95 0 .52.53.946 1.184.946zm0 3.352c.656 0 1.187-.425 1.187-.948 0-.524-.531-.947-1.187-.947-.653 0-1.184.423-1.184.947 0 .523.53.948 1.184.948zm20.285-3.184c.656 0 1.187-.423 1.187-.95 0-.52-.531-.945-1.187-.945-.653 0-1.184.422-1.184.946 0 .526.53.949 1.184.949zm20.117 3.689c.655 0 1.186-.425 1.186-.951 0-.521-.53-.947-1.186-.947-.654 0-1.184.426-1.184.947 0 .526.53.95 1.184.95zm-.334 2.68c.656 0 1.186-.425 1.186-.946 0-.521-.53-.951-1.186-.951-.656 0-1.187.427-1.187.95 0 .522.531.947 1.187.947zm-19.783-3.016c.656 0 1.187-.426 1.187-.95 0-.52-.531-.945-1.187-.945-.653 0-1.184.422-1.184.946 0 .523.53.949 1.184.949zm-39.897 3.016c.653 0 1.184-.425 1.184-.946 0-.521-.53-.951-1.184-.951-.656 0-1.187.427-1.187.95 0 .522.531.947 1.187.947z",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.50199842
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.554 231.006s.168 7.208 4.862 6.202c4.693-1.007 4.191-6.874 4.528-7.208.333-.337.835-.337.835-.337s.67 5.7 5.028 5.03c4.36-.67 4.191-7.71 3.69-8.884l1.006-.337s1.674 8.215 6.704 7.042c5.03-1.174 4.527-6.37 4.527-6.37h.387s1.122 5.532 5.145 5.196c4.021-.334 4.862-1.677 4.358-7.208l2.683-.502s-1.007 8.046 3.852 7.878c4.864-.168 5.03-4.023 5.366-4.693h.733s.274 5.7 4.297 5.7c4.024 0 4.86-4.862 4.86-6.706l3.93.175s-4.096 7.537 1.94 8.543c6.034 1.004 6.202-4.864 6.202-4.864h1.172s-.168 7.545 3.185 7.713c3.35.168 5.364-1.007 5.698-6.538l1.844.67s-1.6 8.942-7.878 7.374c-3.353-.836-4.36-4.691-4.192-5.697 0 0-2.344 4.188-6.872 2.848-4.525-1.34-4.023-4.525-4.023-5.531 0 0-2.722 4.998-6.538 3.852-3.351-1.004-4.694-2.178-4.694-4.525 0 0-1.676 3.855-5.03 3.69-3.353-.169-5.027-2.181-5.195-4.024 0 0-.666 3.603-5.198 3.855-3.017.168-4.694-1.338-5.364-3.353 0 0-.867 3.651-5.195 4.192-2.68.336-5.364-1.173-6.036-3.687 0 0-.668 4.859-5.028 5.531-4.36.67-5.366-2.346-5.366-2.346s-.836 3.857-4.357 4.693c-3.522.838-5.868-.668-6.707-4.19-.838-3.52-.502-5.028-.502-5.028l1.34 1.842",
    style: {
      fontSize: 12,
      fill: "#fc0",
      fillOpacity: 1
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.554 231.006s.168 7.208 4.862 6.202c4.693-1.007 4.191-6.874 4.528-7.208.333-.337.835-.337.835-.337s.67 5.7 5.028 5.03c4.36-.67 4.191-7.71 3.69-8.884l1.006-.337s1.674 8.215 6.704 7.042c5.03-1.174 4.527-6.37 4.527-6.37h.387s1.122 5.532 5.145 5.196c4.021-.334 4.862-1.677 4.358-7.208l2.683-.502s-1.007 8.046 3.852 7.878c4.864-.168 5.03-4.023 5.366-4.693h.733s.274 5.7 4.297 5.7c4.024 0 4.86-4.862 4.86-6.706l3.93.175s-4.096 7.537 1.94 8.543c6.034 1.004 6.202-4.864 6.202-4.864h1.172s-.168 7.545 3.185 7.713c3.35.168 5.364-1.007 5.698-6.538l1.844.67s-1.6 8.942-7.878 7.374c-3.353-.836-4.36-4.691-4.192-5.697 0 0-2.344 4.188-6.872 2.848-4.525-1.34-4.023-4.525-4.023-5.531 0 0-2.722 4.998-6.538 3.852-3.351-1.004-4.694-2.178-4.694-4.525 0 0-1.676 3.855-5.03 3.69-3.353-.169-5.027-2.181-5.195-4.024 0 0-.666 3.603-5.198 3.855-3.017.168-4.694-1.338-5.364-3.353 0 0-.867 3.651-5.195 4.192-2.68.336-5.364-1.173-6.036-3.687 0 0-.668 4.859-5.028 5.531-4.36.67-5.366-2.346-5.366-2.346s-.836 3.857-4.357 4.693c-3.522.838-5.868-.668-6.707-4.19-.838-3.52-.502-5.028-.502-5.028l1.34 1.842.003.002z",
    style: {
      fontSize: 12,
      fill: "#bcac0b",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.65331852
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.277 231.323a1.659 1.659 0 1 0 0-3.32 1.66 1.66 0 0 0 0 3.32",
    style: {
      fontSize: 12,
      fill: "#fc0",
      fillOpacity: 1
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.277 231.323a1.659 1.659 0 1 0 0-3.32 1.66 1.66 0 0 0 0 3.32z",
    style: {
      fontSize: 12,
      fill: "#bcac0b",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.65331852
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.124 227.826a1.66 1.66 0 1 0-.001-3.32 1.66 1.66 0 0 0 0 3.32",
    style: {
      fontSize: 12,
      fill: "#fc0",
      fillOpacity: 1
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.124 227.826a1.66 1.66 0 1 0-.001-3.32 1.66 1.66 0 0 0 0 3.32z",
    style: {
      fontSize: 12,
      fill: "#bcac0b",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.65331852
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.263 228.475a1.66 1.66 0 1 0 0-3.32 1.66 1.66 0 0 0 0 3.32",
    style: {
      fontSize: 12,
      fill: "#fc0",
      fillOpacity: 1
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.263 228.475a1.66 1.66 0 1 0 0-3.32 1.66 1.66 0 0 0 0 3.32z",
    style: {
      fontSize: 12,
      fill: "#bcac0b",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.65331852
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.234 232.005a1.66 1.66 0 0 0 0-3.32 1.66 1.66 0 0 0 0 3.32",
    style: {
      fontSize: 12,
      fill: "#fc0",
      fillOpacity: 1
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.234 232.005a1.66 1.66 0 0 0 0-3.32 1.66 1.66 0 0 0 0 3.32z",
    style: {
      fontSize: 12,
      fill: "#bcac0b",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.65331852
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.214 225.977h-1.508c-.377 1.508-3.584 2.452-3.584 2.452-.377-1.194.44-2.892.44-2.892-3.709-.944-3.709-2.265-3.709-2.265.565-1.256 3.961-1.443 3.961-1.443-.882-1.131-.692-2.954-.692-2.954 2.263.127 4.148 2.387 4.148 2.387s-2.262-1.129-2.01-5.154c0 0 1.256-.06 2.01.754 0 0 0-4.335 1.824-4.837h.187c1.823.502 1.823 4.837 1.823 4.837.754-.814 2.01-.754 2.01-.754.253 4.023-2.01 5.154-2.01 5.154s1.886-2.26 4.148-2.387c0 0 .19 1.82-.692 2.954 0 0 3.397.187 3.961 1.443 0 0 0 1.321-3.708 2.265 0 0 .816 1.698.44 2.892 0 0-3.207-.944-3.585-2.452h-3.456",
    style: {
      fontSize: 12,
      fill: "#fc0",
      fillOpacity: 1
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.214 225.977h-1.508c-.377 1.508-3.584 2.452-3.584 2.452-.377-1.194.44-2.892.44-2.892-3.709-.944-3.709-2.265-3.709-2.265.565-1.256 3.961-1.443 3.961-1.443-.882-1.131-.692-2.954-.692-2.954 2.263.127 4.148 2.387 4.148 2.387s-2.262-1.129-2.01-5.154c0 0 1.256-.06 2.01.754 0 0 0-4.335 1.824-4.837h.187c1.823.502 1.823 4.837 1.823 4.837.754-.814 2.01-.754 2.01-.754.253 4.023-2.01 5.154-2.01 5.154s1.886-2.26 4.148-2.387c0 0 .19 1.82-.692 2.954 0 0 3.397.187 3.961 1.443 0 0 0 1.321-3.708 2.265 0 0 .816 1.698.44 2.892 0 0-3.207-.944-3.585-2.452h-3.456.002z",
    style: {
      fontSize: 12,
      fill: "#bcac0b",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.65331852
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.072 226.834a3.037 3.037 0 1 0 .002-6.074 3.037 3.037 0 0 0-.002 6.074",
    style: {
      fontSize: 12,
      fill: "#fff"
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.072 226.834a3.037 3.037 0 1 0 .002-6.074 3.037 3.037 0 0 0-.002 6.074z",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.40352026
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.072 225.456a1.66 1.66 0 0 0 1.662-1.66 1.66 1.66 0 0 0-3.32 0c0 .917.743 1.66 1.658 1.66",
    style: {
      fontSize: 12,
      fill: "#fff"
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.072 225.456a1.66 1.66 0 0 0 1.662-1.66 1.66 1.66 0 0 0-3.32 0c0 .917.743 1.66 1.658 1.66z",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.25220016
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m319.107 227.944 1.475.32c.046 1.553 2.986 3.15 2.986 3.15.617-1.088.177-2.918.177-2.918 3.824-.14 4.1-1.429 4.1-1.429-.285-1.35-3.564-2.25-3.564-2.25 1.098-.92 1.3-2.743 1.3-2.743-2.24-.353-4.562 1.46-4.562 1.46s2.453-.627 3.055-4.614c0 0-1.217-.324-2.123.312 0 0 .913-4.239-.761-5.113l-.185-.04c-1.888.107-2.803 4.346-2.803 4.346-.565-.958-1.807-1.162-1.807-1.162-1.095 3.879.88 5.464.88 5.464s-1.367-2.61-3.553-3.211c0 0-.57 1.741.053 3.033 0 0-3.358-.53-4.177.58 0 0-.277 1.289 3.149 2.994 0 0-1.158 1.487-1.04 2.733 0 0 3.334-.245 4.02-1.64l1.473.317 1.907.41",
    style: {
      fontSize: 12,
      fill: "#fc0",
      fillOpacity: 1
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m319.107 227.944 1.475.32c.046 1.553 2.986 3.15 2.986 3.15.617-1.088.177-2.918.177-2.918 3.824-.14 4.1-1.429 4.1-1.429-.285-1.35-3.564-2.25-3.564-2.25 1.098-.92 1.3-2.743 1.3-2.743-2.24-.353-4.562 1.46-4.562 1.46s2.453-.627 3.055-4.614c0 0-1.217-.324-2.123.312 0 0 .913-4.239-.761-5.113l-.185-.04c-1.888.107-2.803 4.346-2.803 4.346-.565-.958-1.807-1.162-1.807-1.162-1.095 3.879.88 5.464.88 5.464s-1.367-2.61-3.553-3.211c0 0-.57 1.741.053 3.033 0 0-3.358-.53-4.177.58 0 0-.277 1.289 3.149 2.994 0 0-1.158 1.487-1.04 2.733 0 0 3.334-.245 4.02-1.64l1.473.317 1.907.41",
    style: {
      fontSize: 12,
      fill: "#bcac0b",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.65331852
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.084 228.602a3.038 3.038 0 1 1 1.284-5.939 3.038 3.038 0 0 1-1.284 5.939",
    style: {
      fontSize: 12,
      fill: "#fff"
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.084 228.602a3.038 3.038 0 1 1 1.284-5.939 3.038 3.038 0 0 1-1.284 5.939z",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.40352026
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.377 227.254a1.659 1.659 0 1 1 .699-3.242 1.66 1.66 0 1 1-.699 3.242",
    style: {
      fontSize: 12,
      fill: "#fff"
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.377 227.254a1.659 1.659 0 1 1 .699-3.242 1.66 1.66 0 1 1-.699 3.242z",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.25220016
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m272.266 227.648-1.497.197c-.175 1.547-3.23 2.904-3.23 2.904-.531-1.134.055-2.923.055-2.923-3.8-.447-3.975-1.756-3.975-1.756.396-1.318 3.735-1.955 3.735-1.955-1.021-1.004-1.074-2.836-1.074-2.836 2.26-.17 4.43 1.82 4.43 1.82s-2.393-.823-2.674-4.844c0 0 1.24-.228 2.094.483 0 0-.571-4.3 1.165-5.04l.188-.021c1.873.255 2.445 4.556 2.445 4.556.641-.908 1.895-1.013 1.895-1.013.78 3.955-1.314 5.373-1.314 5.373s1.571-2.489 3.798-2.911c0 0 .427 1.78-.296 3.016 0 0 3.39-.262 4.117.91 0 0 .173 1.31-3.38 2.734 0 0 1.036 1.573.82 2.807 0 0-3.303-.511-3.877-1.957l-1.496.2-1.93.256",
    style: {
      fontSize: 12,
      fill: "#fc0",
      fillOpacity: 1
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m272.266 227.648-1.497.197c-.175 1.547-3.23 2.904-3.23 2.904-.531-1.134.055-2.923.055-2.923-3.8-.447-3.975-1.756-3.975-1.756.396-1.318 3.735-1.955 3.735-1.955-1.021-1.004-1.074-2.836-1.074-2.836 2.26-.17 4.43 1.82 4.43 1.82s-2.393-.823-2.674-4.844c0 0 1.24-.228 2.094.483 0 0-.571-4.3 1.165-5.04l.188-.021c1.873.255 2.445 4.556 2.445 4.556.641-.908 1.895-1.013 1.895-1.013.78 3.955-1.314 5.373-1.314 5.373s1.571-2.489 3.798-2.911c0 0 .427 1.78-.296 3.016 0 0 3.39-.262 4.117.91 0 0 .173 1.31-3.38 2.734 0 0 1.036 1.573.82 2.807 0 0-3.303-.511-3.877-1.957l-1.496.2-1.93.256",
    style: {
      fontSize: 12,
      fill: "#bcac0b",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.65331852
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.229 228.386a3.036 3.036 0 0 0 2.61-3.413 3.035 3.035 0 0 0-3.41-2.609 3.036 3.036 0 1 0 .8 6.022",
    style: {
      fontSize: 12,
      fill: "#fff"
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.229 228.386a3.036 3.036 0 0 0 2.61-3.413 3.035 3.035 0 0 0-3.41-2.609 3.036 3.036 0 1 0 .8 6.022z",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.40352026
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.049 227.02a1.66 1.66 0 0 0-.437-3.29 1.659 1.659 0 1 0 .437 3.29",
    style: {
      fontSize: 12,
      fill: "#fff"
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.049 227.02a1.66 1.66 0 0 0-.437-3.29 1.659 1.659 0 1 0 .437 3.29z",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.25220016
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.16 234.104s-.76-1.998-2.442-1.28c-1.682.718-1.509.98-3.012.889 0 0-.586-1.797.153-2.572 0 0-2.402-.899-2.906-3.007 0 0 1.287-1.494 4.338-.937 0 0-.096-1.516.322-2.183 0 0 3.276 1.013 3.293 2.84 0 0-.982-3.585.747-6.189 0 0 1.535.659 1.436 2.292 0 0 .707-3.36 5.249-2.457 0 0-2.462 2.183-2.585 3.182-.122 1-2.176 2.702-2.212 3.269-.031.564-.281 1.556-.884 2.15-.603.593-.663 1.6-.615 1.914.041.32-.103 1.696-.881 2.09",
    style: {
      fontSize: 12,
      fill: "#fc0",
      fillOpacity: 1
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.16 234.104s-.76-1.998-2.442-1.28c-1.682.718-1.509.98-3.012.889 0 0-.586-1.797.153-2.572 0 0-2.402-.899-2.906-3.007 0 0 1.287-1.494 4.338-.937 0 0-.096-1.516.322-2.183 0 0 3.276 1.013 3.293 2.84 0 0-.982-3.585.747-6.189 0 0 1.535.659 1.436 2.292 0 0 .707-3.36 5.249-2.457 0 0-2.462 2.183-2.585 3.182-.122 1-2.176 2.702-2.212 3.269-.031.564-.281 1.556-.884 2.15-.603.593-.663 1.6-.615 1.914.041.32-.103 1.696-.881 2.09z",
    style: {
      fontSize: 12,
      fill: "#bcac0b",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.65331852
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.701 230.117a3.038 3.038 0 0 1 3.562-2.399c.469.089.886.286 1.242.555-.091.57-.346 1.335-.846 1.828-.602.593-.662 1.6-.617 1.914.034.25-.055 1.148-.468 1.717a3.042 3.042 0 0 1-2.873-3.615",
    style: {
      fontSize: 12,
      fill: "#fff"
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.701 230.117a3.038 3.038 0 0 1 3.562-2.399c.469.089.886.286 1.242.555-.091.57-.346 1.335-.846 1.828-.602.593-.662 1.6-.617 1.914.034.25-.055 1.148-.468 1.717a3.042 3.042 0 0 1-2.873-3.615z",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.40352026
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.056 230.382A1.658 1.658 0 0 1 341 229.07c.409.08.747.308.988.615a2.409 2.409 0 0 1-.33.416c-.602.593-.662 1.6-.617 1.914.007.065.007.175-.005.305a1.657 1.657 0 0 1-1.982-1.938",
    style: {
      fontSize: 12,
      fill: "#fff"
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.056 230.382A1.658 1.658 0 0 1 341 229.07c.409.08.747.308.988.615a2.409 2.409 0 0 1-.33.416c-.602.593-.662 1.6-.617 1.914.007.065.007.175-.005.305a1.657 1.657 0 0 1-1.982-1.938z",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.25220016
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.151 233.269s.88-1.948 2.513-1.132c1.636.817 1.446 1.07 2.957 1.07 0 0 .69-1.761 0-2.578 0 0 2.45-.754 3.08-2.83 0 0-1.195-1.57-4.276-1.193 0 0 .19-1.51-.188-2.2 0 0-3.331.817-3.459 2.64 0 0 1.197-3.522-.377-6.224 0 0-1.57.565-1.57 2.2 0 0-.503-3.396-5.093-2.766 0 0 2.325 2.327 2.39 3.33.062 1.007 2.01 2.83 2.01 3.397 0 .564.19 1.57.755 2.2.567.63.567 1.633.502 1.948-.063.312 0 1.696.756 2.138",
    style: {
      fontSize: 12,
      fill: "#fc0",
      fillOpacity: 1
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.151 233.269s.88-1.948 2.513-1.132c1.636.817 1.446 1.07 2.957 1.07 0 0 .69-1.761 0-2.578 0 0 2.45-.754 3.08-2.83 0 0-1.195-1.57-4.276-1.193 0 0 .19-1.51-.188-2.2 0 0-3.331.817-3.459 2.64 0 0 1.197-3.522-.377-6.224 0 0-1.57.565-1.57 2.2 0 0-.503-3.396-5.093-2.766 0 0 2.325 2.327 2.39 3.33.062 1.007 2.01 2.83 2.01 3.397 0 .564.19 1.57.755 2.2.567.63.567 1.633.502 1.948-.063.312 0 1.696.756 2.138z",
    style: {
      fontSize: 12,
      fill: "#bcac0b",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.65331852
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.842 229.438a3.035 3.035 0 0 0-3.411-2.611c-.471.062-.901.233-1.273.48.057.574.264 1.353.735 1.876.567.63.567 1.633.502 1.948-.048.245-.015 1.148.367 1.739.154.002.313 0 .471-.022a3.035 3.035 0 0 0 2.609-3.41",
    style: {
      fontSize: 12,
      fill: "#fff"
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.842 229.438a3.035 3.035 0 0 0-3.411-2.611c-.471.062-.901.233-1.273.48.057.574.264 1.353.735 1.876.567.63.567 1.633.502 1.948-.048.245-.015 1.148.367 1.739.154.002.313 0 .471-.022a3.035 3.035 0 0 0 2.609-3.41z",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.40352026
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.477 229.618a1.66 1.66 0 0 0-1.864-1.427 1.663 1.663 0 0 0-1.023.555c.089.156.185.305.303.437.567.63.567 1.633.502 1.948-.012.062-.017.17-.015.303.212.06.44.079.67.05a1.663 1.663 0 0 0 1.427-1.866",
    style: {
      fontSize: 12,
      fill: "#fff"
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.477 229.618a1.66 1.66 0 0 0-1.864-1.427 1.663 1.663 0 0 0-1.023.555c.089.156.185.305.303.437.567.63.567 1.633.502 1.948-.012.062-.017.17-.015.303.212.06.44.079.67.05a1.663 1.663 0 0 0 1.427-1.866z",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.25220016
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.241 251.623s33.748-13.22 76.384.284",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.50839722
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.383 241.096c-47.11-14.92-84.66-.838-84.66-.838",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.50199842
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m295.969 237.796-3.774 1.885 3.397 2.138 4.023-2.013-3.646-2.01",
    style: {
      fontSize: 12,
      fill: "red"
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m295.969 237.796-3.774 1.885 3.397 2.138 4.023-2.013-3.646-2.01",
    style: {
      fontSize: 12,
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.50199842
    },
    transform: "matrix(1 0 0 1.00008 -.04 -96.055)"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalicia);
export default __webpack_public_path__ + "static/media/galicia.1ea1c8450e35bdb5717d57254d982f4a.svg";
export { ForwardRef as ReactComponent };